export const CTA_TEXT = {
  SKIP: 'Skip',
  CONTINUE: 'Continue',
}

export const SIGNUP_MOTIVATIONS_TEXT = {
  title: 'What would you like to get out of Gousto?',
  description:
    'Choose up to 3 goals that matter most to you and we’ll tailor your menu to match. Don’t worry, you can still order from the full menu.',
}

export const ORDERED_SIGNUP_MOTIVATIONS = [
  {
    id: '1bea36da-421e-11f0-9fe2-0242ac120002',
    title: 'Try Exciting New Recipes',
  },
  {
    id: '437504d2-421e-11f0-9fe2-0242ac120002',
    title: 'Pack in More Veg',
  },
  {
    id: '482b67aa-421e-11f0-9fe2-0242ac120002',
    title: 'Find Meals for Your Family',
  },
  {
    id: '50164764-421e-11f0-9fe2-0242ac120002',
    title: 'Cook Lower Calorie Meals',
  },
  {
    id: '54b7d652-421e-11f0-9fe2-0242ac120002',
    title: 'Save Time Cooking',
  },
]
